/**
 * @param {string} str
 * @param {boolean} isXhtml
 */
export const nl2br = (str, isXhtml = false) => {
	if (typeof str === 'undefined' || str === null) {
		return '';
	}
	const breakTag = isXhtml ? '<br />' : '<br>';
	return (String(str)).replaceAll(/([^\n\r>]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
};